import BaseApi from "./BaseApi";
const baseUrl = 'api/Report';

interface GeneralSearchResult {
    clients?: SearchResult;
    leads: SearchResult;
    proposals?: SearchResult;
    user?: SearchResult;
}

interface SearchResult {
    list: any[];
    total: number;
}

export interface ProposalProcessingReportItem {
    registerDate: string;
    proposalId?: string;
    proposalNumber?: string;
    logId?: number;
    consultant?: string;
    consultantUserName?: string;
    status: 'generated' | 'error';
    errorType?: string;
    exception?: string;
}

export interface ProposalProcessingReportResult {
    total: number;
    generated: number;
    errors: number;
    items: ProposalProcessingReportItem[];
}

class ReportService {
    static getGeneralSearch(filter: object): Promise<GeneralSearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch`, { params: filter });
    }

    static getGeneralSearch_Clients(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Clients`, { params: filter });
    }

    static getGeneralSearch_Leads(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Leads`, { params: filter });
    }

    static getGeneralSearch_Proposals(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Proposals`, { params: filter });
    }

    static getGeneralSearch_Users(filter: object): Promise<SearchResult> {
        return BaseApi.get(`${baseUrl}/GeneralSearch/Users`, { params: filter });
    }

    static getProposalProcessing(filter: object): Promise<ProposalProcessingReportResult> {
        return BaseApi.get(`${baseUrl}/proposal-processing`, { params: filter });
    }
}

export default ReportService;
